/* eslint-disable react-hooks/exhaustive-deps */
import { SIZE_COVER, SCALE } from '../../constants';
import {
  formatPageNumber,
  ATTENDANCE_TABLE,
  LIST_TABLE_CONTENTS_LABEL_DISPLAY,
} from '../../constants';
import LegendsOfChartCom from '../common/LegendsOfChartCom';
import PageFooter from '../common/PageFooter';
import TableCom from '../common/TableCom';
import bgCover from '@/assets/image/pdfexport/bg-cover.png';
import StackedBarChart from '@/new-components/CRReportPDF/components/StackedBarChart';
import { barChartLabelResponsivePlugins } from '@/new-components/CRReportPDF/ultils';
import { Box, Typography, withStyles } from '@material-ui/core';
import { get, isEmpty } from 'lodash';
import React, { useEffect, useMemo } from 'react';

const width = SIZE_COVER.width * SCALE;
const height = SIZE_COVER.height * SCALE;

const CustomContainer = withStyles({
  root: {
    padding: `0 ${80 * SCALE}px`,
    height,
    width,
    margin: '0 auto',
    backgroundImage: `url(${bgCover})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    paddingTop: `${64 * SCALE}px`,
  },
})(Box);
const Title = withStyles({
  root: {
    fontFamily: 'Lato',
    fontWeight: 700,
    fontSize: 20 * SCALE,
    lineHeight: `${28 * SCALE}px`,
  },
})(Typography);

const Attendance = ({ corporateData, addPaging, startPage, totalPages }) => {
  const totalAttended = get(corporateData, 'overView.totalAttended');

  const totalFemalePercent = get(corporateData, 'overView.totalFemalePercent');

  const totalMalePercent = get(corporateData, 'overView.totalMalePercent');

  const dataAttendance = useMemo(() => {
    if (isEmpty(corporateData?.overView.ageGroups)) return [];
    const ageGroups = get(corporateData, 'overView.ageGroups');

    const table = [...ATTENDANCE_TABLE];
    const dataFemaleTotal = ageGroups.map((it, inx) => ({
      color: '#F5F5F5',
      value: `${it.femaleTotal}`,
      width: table[1][inx + 1]?.width,
      height: table[1][inx + 1]?.height,
    }));

    const dataMaleTotal = ageGroups?.map((it, inx) => ({
      color: '#F5F5F5',
      value: `${it.maleTotal}`,
      width: table[2][inx + 1]?.width,
      height: table[2][inx + 1]?.height,
    }));

    const dataTotal = ageGroups?.map((it, inx) => ({
      color: '#F5F5F5',
      value: `${it.total}`,
      width: table[3][inx + 1]?.width,
      height: table[3][inx + 1]?.height,
    }));

    table[1] = table[1].concat(dataFemaleTotal);
    table[2] = table[2].concat(dataMaleTotal);
    table[3] = table[3].concat(dataTotal);

    return table;
  }, [corporateData]);

  const legends = [
    {
      color: '#F5C5D5',
      title: 'Female',
    },
    {
      color: '#E2F2FF',
      title: 'Male',
    },
  ];
  useEffect(() => {
    addPaging(LIST_TABLE_CONTENTS_LABEL_DISPLAY.Attendance);
  }, []);

  return (
    <CustomContainer>
      <Box display="flex" flexDirection="column" minHeight="100%">
        <Title>Attendance</Title>

        <Box
          mt={5 * SCALE}
          bgcolor="#F5F5F5"
          borderRadius={10 * SCALE}
          width="100%"
          height={62 * SCALE}
          color="#666"
          fontSize={10 * SCALE}
          fontWeight="600"
          fontFamily="OpenSans"
          px={2 * SCALE}
          py={1.625 * SCALE}
        >
          <Box display="flex" gridGap={26 * SCALE}>
            Total Attendance
            <Box color="#333">{totalAttended}</Box>
          </Box>
          <Box
            mt={1.125 * SCALE}
          >{`${totalFemalePercent.formatPercentValue()}% attended are female; ${totalMalePercent.formatPercentValue()}% attended are male.`}</Box>
        </Box>

        <Box mt={5 * SCALE} width={'100%'} height={200 * SCALE}>
          <StackedBarChart
            chartData={corporateData}
            animationDuration={0}
            borderRadius={4 * SCALE}
            barThickness={32 * SCALE}
            fontSize={8 * SCALE}
            plugins={barChartLabelResponsivePlugins}
          />
        </Box>
        <Box ml={6.25 * SCALE} mt={4 * SCALE}>
          <LegendsOfChartCom data={legends} />
        </Box>

        <Box mt={5 * SCALE}>
          <TableCom data={dataAttendance} />
        </Box>
        <PageFooter
          page={formatPageNumber(startPage)}
          totalPages={totalPages}
          title={LIST_TABLE_CONTENTS_LABEL_DISPLAY.Attendance}
        />
      </Box>
    </CustomContainer>
  );
};

export default Attendance;
